/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-10-11 16:21:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-02-01 19:36:30
 */
import request from '@/utils/request'

export interface ChangePasswordParamsType {
  userName: string
  password: string
}

export async function query(): Promise<any> {
  return request('/api/users')
}

// 获取用户头像列表
export function apiAvatarList(params: { ids: number[] }) {
  return request('/api/v2/system/get_avatar_list', {
    method: 'POST',
    data: params
  })
}

// 新版获取权限接口
export async function getPermissionList(params: any) {
  return request('/api/v2/system/get_user_action_permission', {
    method: 'GET',
    data: params
  })
}
